define('SuiteDynamics.CategoryFAQ.SS2Model', [
    'SCModel',
    'Utils'
  ],
  function(
    MultiAddToCartModel,
    Utils
) {
    'use strict';

    var SCModel = MultiAddToCartModel.SCModel;

    function MultiAddToCartModelModule () {
      SCModel.call(this);
        this.urlRoot = function urlRoot() {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath('Modules/AccordionFaqs/SuiteScript2/SuiteDynamics.CategoryFAQ.Service.ss'),
                true
            );
        };
    }

    MultiAddToCartModelModule.prototype = Object.create(SCModel.prototype);

    MultiAddToCartModelModule.prototype.constructor = MultiAddToCartModelModule;

    return MultiAddToCartModelModule;
  }
);
